import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  useTheme,
} from '@mui/material';
import AnimatedElement from './AnimatedElement';

const ContactSection = () => {
  const theme = useTheme();

  // Formular-State
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Hier können Sie die Formular-Logik implementieren
    console.log('Formulardaten:', formData);
    // Reset form
    setFormData({
      name: '',
      email: '',
      message: ''
    });
  };

  return (
    <Box
      id="contact"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: 'primary.white'
      }}
    >
      <Container 
        maxWidth={false} 
        sx={{ 
          maxWidth: '1400px',
          pl: { xs: 2, md: 14 }, // 80px = 10 * 8px (theme spacing)
          pr: 2,
          mx: 'auto',
          mb: 8
        }}
      >
        <AnimatedElement>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '3fr 7fr 1fr' },
            gap: 2,
            alignItems: 'start'
          }}
        >
          {/* Spalte 1: Sektionsüberschrift */}
          <Box>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                 fontSize: { xs: '1.6rem', sm: '1.8rem', md: '2.1rem' },
                fontWeight: 500,
                color: '#000',
                lineHeight: 1.2,
                textAlign: 'left'
              }}
            >
              KONTAKT AUFNEHMEN
            </Typography>
<Box 
                          sx={{
                            height: '4px', 
                            width: '100px', 
                            backgroundColor: 'rgb(58, 123, 62)', 
                            marginTop: { xs: '20px', sm: '30px', md: '40px' },
                            marginBottom: '20px'
                          }}
                        />           
          </Box>

        </Box>
        </AnimatedElement>

        <AnimatedElement>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '3fr 7fr 1fr' },
            gap: 2,
            alignItems: 'start',
            marginLeft: { xs: '40px', md: 0 }
          }}
        >
          {/* Spalte 1: Sektionsüberschrift */}
          <Box>          
            <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: '1rem', md: '1.1rem' },
                            lineHeight: 1.6,
                            color: '#000',
                            textAlign: 'left'
                          }}
                        >
                          <p>Für alle weiteren Fragen Formular ausfüllen oder direkt per E-mail kontaktieren guestphalia@info.de</p>
                        </Typography>
            
          </Box>

          {/* Spalte 2: Zweispaltiger Fließtext */}
          <Box>
            
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
              <TextField
                fullWidth
                name="name"
                label="Name"
                value={formData.name}
                onChange={handleInputChange}
                required
                sx={{ 
                  mb: 3,
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                       borderColor: '#000000',
                       borderWidth: '2px',
                    },
                    '&:hover fieldset': {
                      borderColor: '#3a7b3e',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3a7b3e',
                    },
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: '#3a7b3e',
                  }
                }}
              />
              
              <TextField
                fullWidth
                name="email"
                label="Email"
                type="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                sx={{ 
                  mb: 3,
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#000000',
                      borderWidth: '2px',
                    },
                    '&:hover fieldset': {
                      borderColor: '#3a7b3e',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3a7b3e',
                    },
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: '#3a7b3e',
                  }
                }}
              />
              
              <TextField
                fullWidth
                name="message"
                label="Nachricht"
                multiline
                rows={4}
                value={formData.message}
                onChange={handleInputChange}
                required
                sx={{ 
                  mb: 3,
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#000000',
                      borderWidth: '2px',
                    },
                    '&:hover fieldset': {
                      borderColor: '#3a7b3e',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#3a7b3e',
                    },
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: '#3a7b3e',
                  }
                }}
              />
              
              <Button
                type="submit"
                variant="contained"
                sx={{
                  bgcolor: '#3a7b3e',
                  color: 'white',
                  px: 4,
                  py: 1.5,
                  fontSize: '1rem',
                  fontWeight: 500,
                  textTransform: 'none',
                  '&:hover': {
                    bgcolor: '#2d5f31',
                  }
                }}
              >
                Absenden
              </Button>
            </Box>

          </Box>

          {/* Spalte 3: Gedrehter Text "CORPS" */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'center',
              alignItems: 'flex-start',
              height: '100%',
              minHeight: { xs: '100px', md: '400px' }
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                            <div style={{ height: '100px', width: '2px', backgroundColor: '#3a7b3e', marginLeft: '-4px' }}></div>
                            <Typography
                              variant="h3"
                              sx={{
                                fontSize: { xs: '0.8rem', md: '0.9rem' },
                                fontWeight: 500,
                                color: '#000',
                                writingMode: { xs: 'horizontal-tb', md: 'vertical-rl' },
                                textOrientation: { md: 'mixed' },
                                whiteSpace: 'nowrap',
                                letterSpacing: '0.2em',
                                textAlign: 'center',
                              }}
                            >
                              KONTAKT
                            </Typography>
                          </div>
            
          </Box>
        </Box>
        </AnimatedElement>

        
      </Container>
    </Box>
  );
};

export default ContactSection;